import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../components/common/Sidebar";
import SuperAdminHome from "../components/dashboard/SuperAdmin/SuperAdminHome";

// Import shared components
import AdminManagement from "../components/dashboard/shared/AdminManagement";
import CommissionSettings from "../components/dashboard/shared/CommissionSettings";
import UserManagement from "../components/dashboard/shared/UserManagement";
import SystemConfig from "../components/dashboard/shared/SystemConfig";
import OrganizationManagement from "../components/dashboard/shared/OrganizationManagement";
import WalletCreditManagement from "../components/dashboard/shared/WalletCreditManagement";
import CreditReportManagement from "../components/dashboard/shared/CreditReportManagement";
import UploadDataManagement from "../components/dashboard/shared/UploadDataManagement";
import SupportTicketManagement from "../components/dashboard/shared/SupportTicketManagement";
import Notifications from "../components/dashboard/shared/Notifications";
import SubAdminManagement from "../components/dashboard/shared/SubAdminManagement";
import TransactionHistory from "../components/dashboard/shared/TransactionHistory";
import KycVerificationManagement from "../components/dashboard/SuperAdmin/KycVerificationManagement";
import Profile from "../pages/Profile"; 
import RegistrationRequests from "../components/dashboard/SuperAdmin/RegistrationRequests";
import "../styles/dashboard/SuperAdmin/SuperAdminPortal.css";
import BankAct from "../components/dashboard/shared/BankAct";
import SubAdminReportManagement from "../components/dashboard/SuperAdmin/SubAdminReportManagement";
import ReportManagement from "../components/dashboard/SubAdmin/ReportManagement"; // Shared organization reports

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  return { Authorization: `Bearer ${token}` };
};

export default function SuperAdminPortal() {
  return (
    <div className="superadmin-portal">
      <Sidebar role="SuperAdmin" />
      <div className="content">
        <Routes>
          <Route path="/" element={<SuperAdminHome />} />
          <Route path="dashboard" element={<SuperAdminHome />} />
          <Route path="admins" element={<AdminManagement role="superadmin" />} />
          <Route path="sub-admins" element={<SubAdminManagement role="superadmin" />} />
          <Route path="sub-admin-reports" element={<SubAdminReportManagement />} />
          <Route path="reports" element={<ReportManagement role="superadmin" />} />
          <Route path="commissions" element={<CommissionSettings role="superadmin" />} />
          <Route path="users" element={<UserManagement role="superadmin" />} />
          <Route path="config" element={<SystemConfig role="superadmin" />} />
          <Route path="organizations" element={<OrganizationManagement role="superadmin" />} />
          <Route path="registration-requests" element={<RegistrationRequests />} />
          <Route path="wallets" element={<WalletCreditManagement role="superadmin" />} />
          <Route path="credit-reports" element={<CreditReportManagement role="superadmin" authService={{ getAuthHeader }} />} />
          <Route path="kyc-verifications" element={<KycVerificationManagement />} />
          <Route path="transaction-history" element={<TransactionHistory role="superadmin" />} />
          <Route path="uploaded-data" element={
            <UploadDataManagement
              role="superadmin"
              uploadEndpoint="/superadmin/data-upload/upload"
              historyEndpoint="/superadmin/data-upload/history"
              authHeader={() => require('../services/orgUserAuth.service').default.getAuthHeader()}
              orgSelection={true}
              organizations={[]}
            />
          } />
          <Route path="support-tickets" element={<SupportTicketManagement role="superadmin" />} />
          <Route path="notifications" element={<Notifications role="superadmin" />} />
          <Route path="profile" element={<Profile />} />
          <Route path="bank-act" element={<BankAct role="superadmin" />} />
          <Route path="*" element={<h2>404 - Page Not Found</h2>} />
        </Routes>
      </div>
    </div>
  );
}